import React from 'react'
import { FaMoon, FaSun } from 'react-icons/fa'

const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
}

const ThemeToggle = () => {
  // window is null in server-side rendering
  const hasWindow = () => typeof window !== 'undefined'

  const initialTheme = hasWindow() ? window.localStorage.getItem('theme') : 'light'
  const [theme, updateTheme] = React.useState(initialTheme)

  const handleThemeToggle = () => {
    let themeToRemove
    let themeToAdd

    if (theme === THEMES.LIGHT) {
      themeToRemove = THEMES.LIGHT
      themeToAdd = THEMES.DARK
    } else {
      themeToRemove = THEMES.DARK
      themeToAdd = THEMES.LIGHT
    }

    updateTheme(themeToAdd)
    document.body.classList.remove(themeToRemove)
    document.body.classList.add(themeToAdd)

    // window null in server-side rendering
    if (hasWindow()) {
      window.localStorage.setItem('theme', themeToAdd)
    }
  }

  return (
    <>
      <button className='button' aria-label='Light or Dark Mode Toggle' onClick={handleThemeToggle}>
        {theme === 'light' ? <FaSun /> : <FaMoon />}
      </button>
      <style jsx>
        {`
          .button {
            display: flex;
            align-items: center;
            background-color: transparent;
            border: none;
            outline: none;
            padding: 10px;
            cursor: pointer;
            border-radius: 5px;
            transition: all 0.3s;

            :global(svg) {
              width: 1.5em;
              height: 1.5em;
              opacity: 0.5;
              fill: var(--svg-color);
              transition: all 0.3s;

              &:hover {
                opacity: 1;
              }
            }

            :global(.homepage):not(.fixed) &.button:hover,
            :global(.homepage):not(.fixed) &.button:focus {
              background: rgba(255, 255, 255, 0.6);
            }

            :global(.homepage):not(.fixed) & :global(svg) {
              fill: var(--hero-header-text);
              opacity: 0.85;
            }

            :global(.homepage):not(.fixed) &.button:hover :global(svg),
            :global(.homepage):not(.fixed) &.button:focus :global(svg) {
              fill: var(--color-brand-primary);
              opacity: 1;
            }
          }
        `}
      </style>
    </>
  )
}

export default ThemeToggle
